module.exports = __webpack_public_path__ + "media/logos/LinkedIn-logo-standalone-c0d68435.png";